import React, { useState, ReactNode, useRef } from 'react'
import {
  AccordionPanel,
  AccordionHeader,
  AccordionContent,
  AccordionIcon,
  AccordionDefaultTitle,
} from './Accordion.styles'

type AccordionProps = {
  defaultExpanded?: boolean
  label: JSX.Element | string
  children: ReactNode
  styleProps?: React.CSSProperties
  onToggle?: () => void
}

export const Accordion = ({
  label,
  children,
  defaultExpanded = false,
  styleProps,
  onToggle,
}: AccordionProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const contentRef = useRef<HTMLDivElement>(null)

  const toggleSection = () => {
    setIsExpanded((prev) => !prev)
    onToggle?.()
  }

  return (
    <AccordionPanel>
      <AccordionHeader onClick={toggleSection} style={styleProps}>
        {typeof label === 'string' ? (
          <AccordionDefaultTitle>{label}</AccordionDefaultTitle>
        ) : (
          label
        )}
        <AccordionIcon className={isExpanded ? 'expanded' : ''} />
      </AccordionHeader>
      <AccordionContent
        ref={contentRef}
        style={{
          maxHeight: isExpanded ? `fit-content` : '0',
        }}
        className={isExpanded ? 'expanded' : ''}
      >
        {children}
      </AccordionContent>
    </AccordionPanel>
  )
}
